import { createStore } from 'satcheljs';

export interface PremiumFlightStore {
    flightNames: string[];
    isInit: boolean;
}

const premiumFlightStore: PremiumFlightStore = {
    flightNames: [],
    isInit: false,
};

const store = createStore<PremiumFlightStore>('premiumFlightStore', premiumFlightStore)();
export default store;
